import dayjs from 'dayjs'

/**
 * Ambil aturan pembatasan usia transaksi untuk user login.
 * BE hanya mengirim aturan role yang terpasang ke user di finance.transaction_age_limit.roles.
 *
 * @param ageLimit {Object} finance.transaction_age_limit dari inits
 * @param user {Object} user login dari inits
 * @param flag {string} restrict_view | restrict_modify | restrict_backdate
 * @return {{ age_value: number, age_unit: string }|null} null = tidak dibatasi
 */
export const getAgeLimitRule = (ageLimit, user, flag) => {
  if (!ageLimit || !user || user.is_superuser) {
    return null
  }
  if ((ageLimit.exception_user_ids ?? []).includes(user.id)) {
    return null
  }

  const rule = ageLimit.roles?.[0]
  // age_value 0 berarti nonaktif
  if (!rule?.restricted || !rule[flag] || !Number(rule.age_value)) {
    return null
  }

  return { age_value: rule.age_value, age_unit: rule.age_unit }
}

/**
 * Tanggal paling tua yang masih diizinkan aturan.
 * Dihitung saat dipanggil, supaya ikut maju saat ganti hari.
 *
 * @param rule {Object|null}
 * @return {dayjs.Dayjs|null}
 */
export const getAgeCutoff = (rule) =>
  rule ? dayjs().subtract(rule.age_value, rule.age_unit).startOf('day') : null

/**
 * Cek apakah tanggal transaksi lebih tua dari cutoff aturan.
 *
 * @param date {string|dayjs.Dayjs}
 * @param rule {Object|null}
 * @return {boolean}
 */
export const isOlderThanAgeLimit = (date, rule) => {
  const cutoff = getAgeCutoff(rule)
  return Boolean(cutoff && date && dayjs(date).isBefore(cutoff, 'day'))
}
